import { useContext, useEffect } from 'react';
import OLVectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import PropTypes from 'prop-types';
import GeoMapContext from '../../lib/geo-map/GeoMapContext';
import { useAppSelector } from '../../../app/store';
import reducerPath from '../../../app/reducerPath';
import buildFeaturesFromRoutes from './utils/buildFeaturesFromRoutes';

function RouteVectorLayer({ zIndex, coordinatesWithDate, vehicleId, isManyRoutesMode, speedLimit, stopTime, color }) {
  const isAuthenticated = useAppSelector((state) => state[`${reducerPath.followMode}/counter`]).isActive;

  const zoomController = useAppSelector((state) => state[`${reducerPath.zoomController}/counter`]).zoom;

  const { map } = useContext(GeoMapContext);

  useEffect(() => {
    if (!map) return undefined;

    if (!coordinatesWithDate || !coordinatesWithDate.length) {
      map.getView().setZoom(zoomController);
      return undefined;
    }

    const routesToProcess = isManyRoutesMode ? coordinatesWithDate : [coordinatesWithDate[0]];
    const features = buildFeaturesFromRoutes(routesToProcess, speedLimit, stopTime, color);

    const source = new VectorSource({ features });
    const newVectorLayer = new OLVectorLayer({ source });
    newVectorLayer.setZIndex(zIndex);

    map.addLayer(newVectorLayer);

    if (isAuthenticated) {
      const lastRoute = routesToProcess[routesToProcess.length - 1];
      const lastPoint = lastRoute && lastRoute[lastRoute.length - 1];
      if (lastPoint?.coordinates) {
        map.getView().setCenter(lastPoint.coordinates);
      }
    }

    map.getView().setZoom(zoomController);

    return () => {
      if (map && newVectorLayer) map.removeLayer(newVectorLayer);
    };
  }, [map, coordinatesWithDate, zIndex, vehicleId, isAuthenticated, isManyRoutesMode, speedLimit, stopTime, color]);

  return null;
}

RouteVectorLayer.propTypes = {
  zIndex: PropTypes.number,
  coordinatesWithDate: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
        date: PropTypes.string.isRequired,
      }),
    ),
  ),
  vehicleId: PropTypes.number,
  isManyRoutesMode: PropTypes.bool,
  speedLimit: PropTypes.number,
  stopTime: PropTypes.number,
  color: PropTypes.string,
};

RouteVectorLayer.defaultProps = {
  zIndex: 4,
  coordinatesWithDate: [],
  vehicleId: null,
  isManyRoutesMode: false,
  speedLimit: null,
  stopTime: null,
  color: null,
};

export default RouteVectorLayer;
